import { urlBase } from "./config";
import axiosInstance from "./config/axiosinstance";

async function getConfigLogistics(idEvent) {
  try {
    const config = {
      method: "get",
      url: `${urlBase}/logistics-config/${idEvent}/event`,
      headers: {
        "Content-Type": "application/json",
      },
    };
    const response = await axiosInstance(config);
    return response.data;
  } catch (error) {
    // console.log(error.response);
    return error.response;
  }
}
async function changeConfigLogistics(data, typeRequest, idConfig) {
  const url = idConfig
    ? `${urlBase}/logistics-config/${idConfig}`
    : `${urlBase}/logistics-config`;

  try {
    const config = {
      method: typeRequest,
      url,
      headers: {
        "Content-Type": "application/json",
      },
      data,
    };
    const response = await axiosInstance(config);
    return response.data;
  } catch (error) {
    // console.log(error.response);
    return error.response;
  }
}

export { getConfigLogistics, changeConfigLogistics };
